import React from 'react';
import BreadcrumbsContainer from '../../containers/common/breadcurmbs/BreadcrumbsContainer';
import GroupListContainer from '../../containers/chancemng/group/GroupListContainer';

const GroupListPage = () => (
  <div>
    <BreadcrumbsContainer title="영업관리/영업기회 묶음" icon="common" />
    <GroupListContainer />
  </div>
);

export default GroupListPage;
